theme.SlideShow = (function () {

  function Slider(e) {

    let slideshow = e.querySelector(".slideshow__wrapper"),
        paginationSelector = e.querySelector(".swiper-pagination"),
        navselectorPrev = e.querySelector(".swiper-button-prev"),
        navselectorNext = e.querySelector(".swiper-button-next"),
        autoplaySelctor = e.dataset.sliderAutoplay,
        autoPlayDelay = parseInt(e.dataset.sliderDelay) || 3000,
        loopSelector = e.dataset.sliderLoop,
        slidePagination = e.dataset.pagination;

    let autoplayInit = false;
    let loopInit = false;
    let paginatinInit = "bullets";

    if (autoplaySelctor === "true") {
      autoplayInit = {
        delay: autoPlayDelay,
        disableOnInteraction: false,
        pauseOnMouseEnter: false
      };
    }

    if (loopSelector === "true") {
      loopInit = true;
    }

    if (slidePagination === "counter") {
      paginatinInit = "fraction";
    }

    var swiper = new Swiper(slideshow, {

      loop: loopInit,
      speed: 800,

      autoplay: autoplayInit,

      pagination: {
        el: paginationSelector,
        clickable: true,
        type: paginatinInit,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + "</span>";
        }
      },

      navigation: {
        nextEl: navselectorNext,
        prevEl: navselectorPrev
      },

      autoHeight: true,
      centeredSlides: false,
      watchOverflow: true,
      grabCursor: true,
      observer: true,
      observeParents: true,
      observeSlideChildren: true

    });

    // Restart autoplay after interaction
    swiper.on('touchEnd', function () {
      if (swiper.autoplay) {
        swiper.autoplay.start();
      }
    });

  }

  return Slider;

})();